var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 21,
    fill: "#E6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.75H17C12.59 30.75 11.25 29.41 11.25 25V24.5C11.25 24.09 11.59 23.75 12 23.75C12.96 23.75 13.75 22.96 13.75 22C13.75 21.04 12.96 20.25 12 20.25C11.59 20.25 11.25 19.91 11.25 19.5V19C11.25 14.59 12.59 13.25 17 13.25H27C31.41 13.25 32.75 14.59 32.75 19V20C32.75 20.41 32.41 20.75 32 20.75C31.04 20.75 30.25 21.54 30.25 22.5C30.25 23.46 31.04 24.25 32 24.25C32.41 24.25 32.75 24.59 32.75 25C32.75 29.41 31.41 30.75 27 30.75ZM12.75 25.16C12.77 28.6 13.48 29.25 17 29.25H27C30.34 29.25 31.15 28.66 31.24 25.66C29.81 25.32 28.75 24.03 28.75 22.5C28.75 20.97 29.82 19.68 31.25 19.34V19C31.25 15.43 30.58 14.75 27 14.75H17C13.48 14.75 12.77 15.4 12.75 18.84C14.18 19.18 15.25 20.47 15.25 22C15.25 23.53 14.18 24.82 12.75 25.16Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.25C19.59 17.25 19.25 16.91 19.25 16.5V14C19.25 13.59 19.59 13.25 20 13.25C20.41 13.25 20.75 13.59 20.75 14V16.5C20.75 16.91 20.41 17.25 20 17.25Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24.58C19.59 24.58 19.25 24.24 19.25 23.83V20.16C19.25 19.75 19.59 19.41 20 19.41C20.41 19.41 20.75 19.75 20.75 20.16V23.83C20.75 24.25 20.41 24.58 20 24.58Z",
    fill: "#26B5ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.75C19.59 30.75 19.25 30.41 19.25 30V27.5C19.25 27.09 19.59 26.75 20 26.75C20.41 26.75 20.75 27.09 20.75 27.5V30C20.75 30.41 20.41 30.75 20 30.75Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsTicket);
export default __webpack_public_path__ + "static/media/statistics-ticket.091f8b751cb1dfe57d3de9345439c4e1.svg";
export { ForwardRef as ReactComponent };